import { Component, Input, SimpleChanges, OnChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-day-part-sales-by-department',
  templateUrl: './day-part-sales-by-department.component.html',
  styleUrls: ['./day-part-sales-by-department.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class DayPartSalesByDepartmentComponent {
  @Input() dashboardData: any;

  @ViewChild('dtShopTimeWiseSalesChart', { static: false }) chartRef!: ElementRef<HTMLCanvasElement>;
  chart: Chart | null = null;

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      this.renderChart();
    }
  }

  renderChart() {
    if (!this.dashboardData || !this.chartRef) return;

    const dashboardHourlySales = this.dashboardData.dashboardHourlySales || [];
    const labels = dashboardHourlySales.map((r:any) => this.formatLabel(r));
    const sushi = dashboardHourlySales.map((r:any) => parseFloat(r.sushi_sales));
    const bento = dashboardHourlySales.map((r:any) => parseFloat(r.bento_sales));
    const common = dashboardHourlySales.map((r:any) => parseFloat(r.common_sales));

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.chartRef.nativeElement.getContext('2d')!, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          { label: 'Sushi', data: sushi, backgroundColor: 'rgb(230, 219, 12)', barThickness: 50 },
          { label: 'Bento', data: bento, backgroundColor: '#cc6d19', barThickness: 50 },
          { label: 'Common', data: common, backgroundColor: 'rgba(54,162,235,0.7)', barThickness: 50 }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            labels: {
              font: { size: 14 }
            }
          }
        },
        scales: {
          x: {
            type: 'category',
            stacked: true,
            ticks: {
                font: { size: 14 },
                maxRotation: 45,
                minRotation: 0,
                // autoSkip: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              font: { size: 14 },
              callback: function(value:any) { return '$' + value; }
            }
          }
        }
      }
    });
  }

  formatLabel(r: any): string {
    const fromTime = this.formatTime12(r.time_from);
    const toTime = this.formatTime12(r.time_to);
    if (r.time_slot.includes('breakfast')) return `Breakfast (${fromTime} - ${toTime})`;
    if (r.time_slot.includes('lunch')) return `Lunch (${fromTime} - ${toTime})`;
    if (r.time_slot.includes('tea')) return `Tea Time (${fromTime} - ${toTime})`;
    if (r.time_slot.includes('dinner')) return `Dinner (${fromTime} - ${toTime})`;
    return `${r.time_slot} (${fromTime} - ${toTime})`;
  }

  formatTime12(timeStr: string): string {
    if (!timeStr) return '';
    const [h] = timeStr.split(':');
    let hour = parseInt(h, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}${ampm}`;
  }

}
